import React from 'react'
import PropTypes from 'prop-types'
import Immutable from 'seamless-immutable'
import Illustration from 'components/Illustration'

import { Link } from 'blocket-ui'

const styles = Immutable.from({
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    backgroundColor: '#FFFFFF',
    flex: '1 1 auto',
    margin: '16px',
  },
  titleWrapper: {
    lineHeight: '1.27',
    textAlign: 'center',
    fontSize: '24px',
    fontColor: '#000000',
    paddingTop: '20px',
    paddingBottom: '10px',
    fontFamily: "'BlocketSans-Medium', sans-serif",
  },
  messageWrapper: {
    lineHeight: '1.62',
    textAlign: 'center',
    color: '#000000',
    fontSize: '16px',
    paddingBottom: '10px',
  },
  link: {
    color: '#4182c3',
  },
})

const ServerErrorComponent = ({ baseUrl }) => (
  <div style={styles.container}>
    <style type="text/css">
      {`
          html {
            min-height: 100%;
          }
          body {
            display: flex;
            flex-direction: column;
          }
          #root {
            display: flex;
            flex: 1;
            flex-direction: column;
          }
        `}
    </style>
    <Illustration image="needhelp" maxWidth={280} baseUrl={baseUrl} />
    <div style={styles.titleWrapper}>Ånej!</div>
    <div style={styles.messageWrapper}>Något blev fel. Försök igen.</div>
    <Link style={styles.link} to={baseUrl || 'https://blocket.se'}>
      Tillbaka till startsidan
    </Link>
  </div>
)

ServerErrorComponent.propTypes = {
  baseUrl: PropTypes.string,
}

export default ServerErrorComponent
